<template>
  <div class="order-info-module" v-loading="infoLoading">
    <div class="sec-hd">
      <h2 class="title">工单信息</h2>
    </div>
    <section class="sec-module">
      <div class="module-hd">
        <h3 class="title">发单信息总览</h3>
        <el-date-picker
          v-model="year"
          size="mini"
          type="year"
          :default-value="year"
          format="yyyy"
          value-format="yyyy"
          @change="loadData"
          placeholder="请选择">
        </el-date-picker>
      </div>
      <ul class="info">
        <li class="info-item">
          <span class="count">{{orderInfo.sendCount}}</span>
          <div class="desc">总发布工单/单</div>
        </li>
        <li class="info-item">
          <span class="count">{{orderInfo.serverCount}}</span>
          <div class="desc">服务中工单/单</div>
        </li>
        <li class="info-item">
          <span class="count">{{orderInfo.succCount}}</span>
          <div class="desc">已完成工单/单</div>
        </li>
        <li class="info-item">
          <span class="count">{{orderInfo.closeCount}}</span>
          <div class="desc">已关闭工单/单</div>
        </li>
        <li class="info-item">
          <span class="count price">￥{{orderInfo.noTaxAmount | formatPrice}}</span>
          <div class="tax">含税￥{{orderInfo.taxAmount | formatPrice}}</div>
          <div class="desc">成单总金额</div>
        </li>
      </ul>
    </section>
  </div>
</template>
<script>
import {
  orderSummar
} from '@/service/customerInformation.js';
export default {
  data(){
    return{
      orderInfo:{},
      year:new Date().getFullYear()+'',

      infoLoading: false,
    }
  },
  // mounted() {
  //   this.loadData();
  // },
  methods: {
    getEveryData(){
      this.year = new Date().getFullYear()+'';
      this.loadData();
    },
    loadData(){
      this.infoLoading = true
      let companyId = Number(this.$route.query.companyId);
      orderSummar({
        companyId:companyId,
        year:this.year,
      }).then(r=>{
        console.log(r)
        this.infoLoading = false
        if(r.Result==1){
          this.orderInfo=r.Data ||{};
        }
      })
    },
  },
}
</script>
<style lang="scss">
.order-info-module{
  .sec-hd{
		overflow: hidden;
		margin-bottom: 20px;
		.title{
			font-size: 18px;
			color: #333;
			line-height: 40px;
			font-weight: bold;
      float: left;
		}
	}
  .sec-module{
    background-color: #F9F9F9;
    border: 1px solid #E5E5E5;
    padding: 10px 20px;
    margin-bottom: 10px;
    .module-hd{
      overflow: hidden;
      margin-bottom: 20px;
    }
    .title{
      font-size: 16px;
			color: #333;
			line-height: 28px;
      float: left;
      font-weight: normal;
    }
    .el-date-editor{
      float: right;
      width: 100px;
      // .el-input__inner{
      //   border: 0;
      //   background-color: transparent;
      // }
    }
  }
  .info{
    overflow: hidden;
    .info-item{
      float: left;
      width: 20%;
      list-style: none;
      text-align: center;
      padding: 10px 0;
    }
    .count{
      font-size: 24px;
      color: #333;
      line-height: 30px;
      font-family:"arial","Microsoft Yahei";
      padding-left: 5px;
      padding-right: 5px;
      cursor: pointer;
      &.price{
        color: #ff3838;
      }
    }
    .desc{
      font-size: 12px;
      color: #999;
      line-height: 18px;
      margin-top: 18px;
    }
    .tax{
      font-size: 12px;
      color: #666;
      line-height: 18px;
    }
    .tax+.desc{
      margin-top: 0;
    }
  }
}
</style>